import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-serif font-bold text-white mb-4 tracking-wider">NAWASENA</h3>
            <p className="text-stone-400 mb-6 leading-relaxed">
              Menghadirkan pengalaman kuliner autentik Indonesia dan Western dalam suasana taman yang asri dan ballroom yang elegan.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-white mb-6">Tautan Cepat</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-emerald-500 transition-colors">Beranda</Link></li>
              <li><Link to="/about" className="hover:text-emerald-500 transition-colors">Tentang Kami</Link></li>
              <li><Link to="/menu" className="hover:text-emerald-500 transition-colors">Menu</Link></li>
              <li><Link to="/contact" className="hover:text-emerald-500 transition-colors">Reservasi & Kontak</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-white mb-6">Hubungi Kami</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-emerald-500 mt-1 shrink-0" size={20} />
                <span>Jl. H. Agus Salim No.90, Pandean, Kec. Manguharjo, Kota Madiun, Jawa Timur 63129</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-emerald-500 shrink-0" size={20} />
                <span>0811-3420-099</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-emerald-500 shrink-0" size={20} />
                <span>info@nawasenagardenresto.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 text-center text-sm text-stone-500">
          <p>&copy; {new Date().getFullYear()} Nawasena Garden Resto & Ballroom. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
